module.exports = __webpack_public_path__ + "bitmap@2x.png?b7c8ffffe4d4601d6205b3678bf578d4";